import { uniqBy } from 'lodash'

import API from '../../api/api'

export const GET_PACKAGES = 'PACKAGES/GET_PACKAGES'
export const DELETE_PACKAGE = 'PACKAGES/DELETE_PACKAGE'
export const UPDATE_PACKAGE = 'PACKAGES/UPDATE_PACKAGE'
export const ADD_PACKAGE = 'PACKAGES/ADD_PACKAGE'
export const CHECKOUT_PACKAGE = 'PACKAGES/CHECKOUT_PACKAGE'
export const UPDATE_PACKAGE_COMMENT = 'PACKAGES/UPDATE_PACKAGE_COMMENT'

const initialState = {
  packages: [],
  packagesFilterCounters: {},
}

export const whichPackagesFilter = (status) => {
  switch (status) {
    case 'Pending':
      return 'countPending'
    case 'Requested':
      return 'countRequested'
    case 'Received':
      return 'countReceived'
    default:
      return ''
  }
}

const packagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PACKAGES: {
      return {
        ...state,
        packages: uniqBy([...action.packages], 'id'),
        packagesFilterCounters: action.filterCounters,
      }
    }
    case ADD_PACKAGE: {
      return {
        ...state,
        packages: [action.data, ...state.packages],
        packagesFilterCounters: {
          ...state.packagesFilterCounters,
          count: state.packagesFilterCounters.count + 1,
          countPending: state.packagesFilterCounters.countPending + 1,
        },
      }
    }
    case UPDATE_PACKAGE:
      return {
        ...state,
        packages: state.packages.map((packageData) =>
          packageData.id === action.data.id ? { ...packageData, ...action.data } : packageData,
        ),
      }
    case CHECKOUT_PACKAGE:
      const packageStatus = whichPackagesFilter(action.packageStatus)
      return {
        ...state,
        packages: state.packages.map((packageData) =>
          packageData.id === action.data.id ? { ...packageData, ...action.data } : packageData,
        ),
        packagesFilterCounters: {
          ...state.packagesFilterCounters,
          countReceived: state.packagesFilterCounters.countReceived + 1,
          [packageStatus]: state.packagesFilterCounters[packageStatus] - 1,
        },
      }
    case DELETE_PACKAGE:
      const filterCounterKey = whichPackagesFilter(action.packageStatus)
      return {
        ...state,
        packages: state.packages.filter((packageData) => packageData.id !== action.packageId),
        packagesFilterCounters: {
          ...state.packagesFilterCounters,
          count: state.packagesFilterCounters.count - 1,
          [filterCounterKey]: state.packagesFilterCounters[filterCounterKey] - 1,
        },
      }
    case UPDATE_PACKAGE_COMMENT:
      return {
        ...state,
        packages: state.packages.map((packageData) =>
          packageData.id === action.data.id
            ? { ...packageData, comment: action.data.comment }
            : packageData,
        ),
      }
    default:
      return state
  }
}

export const getPackagesWithCount = ({
  page = 1,
  buildingId = 0,
  query = '',
  pageSize = 300,
  status = '',
  startDate,
  endDate,
  sort,
  locations,
}) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getPackagesWithCount({
      buildingId,
      start,
      pageSize,
      query,
      status,
      startDate,
      endDate,
      sort,
      locations,
    })
      .then(({ data: { results, count, countPending, countReceived, countRequested } }) => {
        dispatch({
          type: GET_PACKAGES,
          packages: results,
          count,
          filterCounters: {
            count,
            countPending,
            countReceived,
            countRequested,
          },
          page,
        })
        return Promise.resolve({
          results,
          count,
          countPending,
          countReceived,
          countRequested,
        })
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

export const asyncDeletePackage = (packageId, packageStatus) => {
  return async (dispatch) => {
    try {
      await API.deletePackage(packageId)
      dispatch({ type: DELETE_PACKAGE, packageId, packageStatus })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const asyncCheckoutPackage = (packageNewData, status) => {
  return async (dispatch) => {
    try {
      const { data } = await API.updatePackage(packageNewData)
      dispatch({
        type: CHECKOUT_PACKAGE,
        data,
        packageStatus: status,
      })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const asyncUpdatePackage = (packageNewData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.updatePackage(packageNewData)
      dispatch({
        type: UPDATE_PACKAGE,
        data,
      })
      return data
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const asyncAddPackage = (packageNewData) => {
  return async (dispatch) => {
    try {
      const { data } = await API.addPackage(packageNewData)
      dispatch({
        type: ADD_PACKAGE,
        data,
      })
      return data
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : 'There was a problem creating the package.'
      throw new Error(message)
    }
  }
}

export const asyncUpdatePackageComment = (packageId, comment) => {
  return async (dispatch) => {
    try {
      const { data } = await API.updatePackageComment(packageId, comment)
      dispatch({
        type: UPDATE_PACKAGE_COMMENT,
        data,
      })
      return data
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const selectPackages = (state) => state.packages.packages
export const selectPackagesFilterCounters = (state) => state.packages.packagesFilterCounters

export default packagesReducer
